// src/GlobalChatNotifier.js
import React, { useEffect, useState } from 'react'
import { collection, query, where, onSnapshot } from 'firebase/firestore'
import { db } from './firebaseConfig'
import { MessageCircle, X } from 'lucide-react' // ❌ Import Link dihapus

export default function GlobalChatNotifier() {
  const [waitingCount, setWaitingCount] = useState(0)
  const [forceHide, setForceHide] = useState(false)

  useEffect(() => {
    setForceHide(false)
    
    const q = query(collection(db, 'chats'), where('waiting', '==', true))
    
    const unsub = onSnapshot(q, (snap) => {
      const validDocs = snap.docs.filter(d => {
        const data = d.data();
        return data.userId || data.mitraId;
      });
      
      setWaitingCount(validDocs.length)
    })

    return () => unsub()
  }, [])

  if (waitingCount === 0 || forceHide) return null

  return (
    <div className="fixed bottom-8 right-8 z-[9999] flex flex-col items-end gap-2">
      
      <button 
        onClick={(e) => {
          e.stopPropagation(); // ✅ Mencegah klik tembus
          setForceHide(true);
        }}
        className="bg-gray-800 text-gray-400 hover:text-white p-1 rounded-full shadow-lg border border-gray-700 transition"
        title="Abaikan sementara"
      >
        <X size={14} />
      </button>

      {/* ✅ Gunakan tag div biasa dengan fungsi window.location.href */}
      <div 
        onClick={() => { window.location.href = '/inbox' }}
        className="bg-red-600 text-white px-5 py-3 rounded-2xl shadow-2xl cursor-pointer hover:bg-red-700 transition-all flex items-center gap-3 animate-bounce border-2 border-red-400"
        title="Buka Kotak Masuk"
      >
        <div className="relative flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
        </div>
        
        <MessageCircle size={20} />
        
        <div className="font-bold text-sm">
          {waitingCount} Permintaan Chat Baru!
        </div>
      </div>

    </div>
  )
}